<cmps-dialog class="cmps-wp-info-dialog">
    <cmps-dialog-header
        class="cmps-cdk-border-b-solid cmps-cdk-border-b-width-1p cmps-cdk-border-b-color-grey-300"
        [closeTooltip]="_i18n._763_CLOSE | translate"
    >
        <div class="cmps-cdk-font-size-14p cmps-cdk-font-bold">
            {{ _i18n._11274_WINNING_PERCENTAGE_EXPLANATION | translate }}
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body>
        <img
            class="cmps-cdk-w-100pct cmps-cdk-h-auto"
            src="assets/winning-percentage-legend.png"
            alt=""
            aria-hidden="true"
        />
    </cmps-dialog-body>
</cmps-dialog>
